import {t} from 'i18next';

type AuthRouteKeys = 'signIn' | 'signUp' | 'emailCheck' | 'resetPassword' | 'forgotPassword' | 'emailCheckResetLink';
type AppRouteKeys =
  | 'register'
  | 'dashboard'
  | 'garages'
  | 'garage'
  | 'garageCreate'
  | 'garageEdit'
  | 'vehicle'
  | 'vehicleCreate'
  | 'vehicleEdit'
  | 'reservations'
  | 'reservationCreate'
  | 'reservationCreateCarId'
  | 'services'
  | 'serviceEdit'
  | 'serviceCreate'
  | 'tasks'
  | 'task'
  | 'editTask'
  | 'serviceCreateCarId'
  | 'serviceTaskAdd'
  | 'service'
  | 'reservationEdit'
  | 'reservation'
  | 'reservationId'
  | 'customers'
  | 'customer'
  | 'customerEdit'
  | 'customerCreate'
  | 'employees'
  | 'employee'
  | 'employeeEdit'
  | 'employeeCreate';

type CalendarRoute<T extends string> = {
  [route in T]: {
    url: string;
    title: string;
  };
};

export const AuthRoutePaths: CalendarRoute<AuthRouteKeys> = {
  signIn: {
    url: '/',
    title: t('Sign in'),
  },
  signUp: {
    url: '/signup',
    title: t('Sign up'),
  },
  emailCheck: {
    url: '/activate',
    title: t('Email Check'),
  },
  forgotPassword: {
    url: '/forgot-password',
    title: t('Forgot Password'),
  },
  emailCheckResetLink: {
    url: '/check-reset-link',
    title: t('Email Check Reset Link'),
  },
  resetPassword: {
    url: '/reset-password',
    title: t('Reset Password'),
  },
};

export const AppRoutePaths: CalendarRoute<AppRouteKeys> = {
  dashboard: {
    url: '/dashboard',
    title: t('Dashboard'),
  },
  garages: {
    url: '/garages',
    title: t('Garages'),
  },
  garage: {
    url: '/garages/:garageId',
    title: t('Garage'),
  },
  garageCreate: {
    url: '/garages/create',
    title: t('Add Garage'),
  },
  garageEdit: {
    url: '/garages/:garageId/edit',
    title: t('Edit Garage'),
  },
  vehicleCreate: {
    url: '/garages/:garageId/add_vehicle',
    title: t('Add Car'),
  },
  vehicleEdit: {
    url: 'garages/:garageId/vehicles/:vehicleId/edit',
    title: t('Edit Car'),
  },
  vehicle: {
    url: 'garages/:garageId/vehicles/:vehicleId',
    title: t('Car'),
  },
  services: {
    url: '/services',
    title: t('Services'),
  },
  service: {
    url: '/services/:serviceId',
    title: t('Service'),
  },
  serviceCreate: {
    url: '/services/create',
    title: t('Add Service'),
  },
  serviceCreateCarId: {
    url: '/services/create/:vehicleId',
    title: t('Add Service'),
  },
  serviceEdit: {
    url: '/services/:serviceId/edit',
    title: t('Edit Service'),
  },
  tasks: {
    url: '/tasks',
    title: t('Tasks'),
  },
  task: {
    url: '/tasks/:taskId',
    title: t('Task'),
  },
  editTask: {
    url: '/tasks/:taskId/edit',
    title: t('Edit task'),
  },
  serviceTaskAdd: {
    url: '/services/:serviceId/addtask',
    title: t('Add service task'),
  },
  reservations: {
    url: '/reservations',
    title: t('Reservations'),
  },
  reservationCreateCarId: {
    url: '/reservations/create/:vehicleId',
    title: t('Add Reservation'),
  },
  reservationCreate: {
    url: '/reservations/create',
    title: t('Add Reservation'),
  },
  reservation: {
    url: '/reservation',
    title: t('Reservation'),
  },
  reservationId: {
    url: '/reservation/:reservationId',
    title: t('Reservation'),
  },
  reservationEdit: {
    url: '/reservation/:reservationId/edit',
    title: t('Edit reservation'),
  },
  register: {
    url: '/register',
    title: t('Register'),
  },
  customers: {
    url: '/customers',
    title: t('Customers'),
  },
  customer: {
    url: '/customers/:customerId',
    title: t('Customer'),
  },
  customerCreate: {
    url: '/customers/create',
    title: t('Add Customer'),
  },
  customerEdit: {
    url: '/customers/:customerId/edit',
    title: t('Edit Customer'),
  },
  employees: {
    url: '/employees',
    title: t('Employees'),
  },
  employee: {
    url: '/employees/:employeeId',
    title: t('Employee'),
  },
  employeeCreate: {
    url: '/employees/create',
    title: t('Add Employee'),
  },
  employeeEdit: {
    url: '/employees/:employeeId/edit',
    title: t('Edit Employee'),
  },
};
